import React, { useEffect } from 'react';
import { CreditNoteForm } from '../../Components/Form';
import { FormLayout } from '../../Components';
import { CreditNoteIcon } from '../../Assets/Navigation/NavigationIcons';
import { t } from 'i18next';

const AddCreditNote = (props) => {
  useEffect(() => {
    document.title = t('CreditNote.add_cn');
  }, []);

  return (
    <FormLayout
      title={t('CreditNote.add_cn')}
      Icon={CreditNoteIcon}
      closeUrl="/creditnotes"
      iconstyle="credit_general_module_icon"
    >
      <CreditNoteForm type="add" handleToast={props.handleToast} />
    </FormLayout>
  );
};

export default AddCreditNote;
